module.exports = __webpack_public_path__ + "media/images/city/055-parthenon-fdb4e3781533736489df346bed152334.svg";